module.exports = __webpack_public_path__ + "static/media/pisces.b3da22ac.svg";